module.exports = {"220172001":"永兴街道","220172002":"净月街道","220172003":"福祉街道","220172004":"德正街道","220172005":"彩织街道","220172006":"德容街道","220172007":"博硕街道","220172100":"新立城镇","220172101":"新湖镇","220172102":"玉潭镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/220172.json
// module id = 612
// module chunks = 0